import React from 'react';
import {useMutation} from '@tanstack/react-query';

import {useExperimentsStore} from 'apps/experiments/src/store';
import {addToast} from 'common/components/toast-area/toast-manager';
import {ToastType} from 'common/components/toast/types';
import {useExperimentsApi} from 'apps/experiments/src/api/experiments';

import {useExperimentPageContext} from '../context';
import {PageTrackingEvent, trackExperimentPageAction} from '../tracking';

export function useForceConcludeExperiment() {
  const {projectId, workspaceId} = useExperimentPageContext();

  const experimentState = useExperimentsStore((state) => state.experimentState!);
  const experimentSetState = useExperimentsStore((state) => state.experimentSetState);
  const setExperimentLoading = useExperimentsStore((state) => state.setExperimentLoading);

  const {forceConcludeExperiment} = useExperimentsApi({
    projectId,
    workspaceId,
  });

  const forceConcludeMutation = useMutation({
    mutationFn: forceConcludeExperiment,
    onSuccess: (data) => {
      experimentSetState(data, false);
    },
    onError: () => {
      addToast({
        message: `Failed to force conclude experiment`,
        type: ToastType.ERROR,
        timeout: 6000,
      });
    },
    onSettled: () => {
      setExperimentLoading(false);
    },
  });

  const forceComplete = React.useCallback(() => {
    setExperimentLoading(true);
    forceConcludeMutation.mutate({
      id: experimentState.id,
    });
    trackExperimentPageAction({
      event: PageTrackingEvent.ForceComplete,
      experiment: experimentState,
    });
  }, [experimentState, forceConcludeMutation, setExperimentLoading]);

  return forceComplete;
}
